"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_router_1 = require("react-router");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var ImpersonatingBanner_1 = require("containers/Admin/CustomerManagement/ImpersonateTable/ImpersonatingBanner");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var hooks_1 = require("utils/hooks");
var FreeTrialPlanModal_1 = __importDefault(require("./FreeTrialPlanModal"));
var FreePlanCheckout = function (_a) {
    var profile = _a.profile, hasTakenTrial = _a.hasTakenTrial;
    var _b = __read((0, hooks_1.useSubmitter)('users', profile === null || profile === void 0 ? void 0 : profile.id, { closedCheckoutBanner: true }), 1), userDismissBanner = _b[0];
    var _c = __read((0, react_1.useState)(false), 2), openModal = _c[0], setOpenModal = _c[1];
    var history = (0, react_router_1.useHistory)();
    if (profile === null || profile === void 0 ? void 0 : profile.closedCheckoutBanner) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(ImpersonatingBanner_1.StyledBox, __assign({ display: "flex", justifyContent: "center", alignItems: "center", className: ImpersonatingBanner_1.classes.bannerWrapper }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: "You are currently on a free plan. Upgrade to access more features" })), !hasTakenTrial
                ? ((0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () { history.push('/settings/billing/plan'); }, sx: { mx: 3 } }, { children: "Upgrade now" })))
                : ((0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () { return setOpenModal(true); }, sx: { mx: 3 } }, { children: "Upgrade now" }))), (0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ color: "neutral", size: "small", onClick: function () { return userDismissBanner(); } }, { children: "Dismiss" })), (0, jsx_runtime_1.jsx)(FreeTrialPlanModal_1.default, { open: openModal, onClose: function () { return setOpenModal(false); } })] })));
};
exports.default = FreePlanCheckout;
